<template>
  <Doughnut
    v-if="Array.isArray(chartData.datasets)"
    ref="doughnutChart"
    :options="chartOptions"
    :data="chartData"
  />
</template>

<script>
// https://vue-chartjs.org/examples/
import { Doughnut } from 'vue-chartjs'
import { Colors } from 'chart.js'
import { htmlLegendPlugin } from './plugins/htmlLegendPlugin'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
  Colors,
  htmlLegendPlugin
)

export default {
  name: 'DoughnutChart',
  components: {
    Doughnut
  },
  props: {
    chartData: {
      type: Object,
      required: true
    },
    uniqid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          htmlLegend: {
            containerID: this.uniqid
          },
          legend: {
            display: false
          },
          tooltip: {
            callbacks: {
              label: (tooltipItem) => {
                const dataset = tooltipItem.dataset
                const total = dataset.data.reduce(
                  (sum, val) => sum + (val?.value ?? 0),
                  0
                )
                const value = dataset.data[tooltipItem.dataIndex]?.value ?? 0
                const percentage = ((value / total) * 100).toFixed(1)

                return ` ${tooltipItem.label}: ${value} (${percentage}%)`
              }
            }
          },
          detailedTablePlugin: false,
          groupedLegendPlugin: false
        }
      }
    }
  },
  methods: {
    renderChartData() {
      this.$refs.doughnutChart.chart.update()
    }
  }
}
</script>
